import { languages } from "./languages"
import { authPages, teacherPages, methodistPages } from "./pages"

export const mock = {
  languages,
  authPages,
  teacherPages,
  methodistPages,
}